import React from "react";
import { FileWarning, Flame, ShieldAlert, Boxes, Share2 } from "lucide-react";
import { Reveal, Kicker, Section } from "@/components/landing/kit";
import { MISTAKES } from "@/lib/site-data";

const ICONS = [FileWarning, Flame, ShieldAlert, Boxes, Share2];

const Mistakes = () => (
  <Section id="mistakes" className="border-y border-[#E5E8F0] bg-white py-24 sm:py-32">
    <Reveal className="mx-auto mb-16 max-w-3xl text-center">
      <Kicker className="mb-5 justify-center">The 5 reasons DIY fails</Kicker>
      <h2 className="text-balance font-heading text-4xl font-black leading-[0.98] tracking-tight text-[#0F1117] sm:text-6xl">
        Here&apos;s exactly why most people never profit on marketplaces alone.
      </h2>
      <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-[#4B5262] sm:text-lg">
        Over nine years we&apos;ve onboarded 400+ stores. The owners who try to do it all
        themselves stall for the same five reasons — and it&apos;s exactly what
        done-for-you management solves.
      </p>
    </Reveal>

    <div className="space-y-5">
      {MISTAKES.map((m, i) => {
        const Icon = ICONS[i % ICONS.length];
        return (
          <Reveal
            key={m.n}
            delay={(i % 2) * 0.06}
            className="grid grid-cols-1 gap-6 rounded-3xl border border-[#E5E8F0] bg-white p-7 shadow-sm transition-all duration-300 hover:border-[#2D5BFF]/50 hover:shadow-md sm:grid-cols-12 sm:p-9"
            data-testid={`mistake-card-${i}`}
          >
            <div className="flex items-center gap-5 sm:col-span-3 sm:flex-col sm:items-start sm:gap-6">
              <span className="num-ghost font-heading text-6xl sm:text-7xl">{m.n}</span>
              <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#2D5BFF]/10 text-[#2D5BFF]">
                <Icon className="h-6 w-6" />
              </span>
            </div>
            <div className="sm:col-span-9">
              <h3 className="font-heading text-2xl font-bold leading-tight tracking-tight text-[#0F1117] sm:text-3xl">
                {m.title}
              </h3>
              <p className="mt-2 font-heading text-sm font-bold text-[#2D5BFF] sm:text-base">
                {m.sub}
              </p>
              <p className="mt-3 max-w-2xl text-base leading-relaxed text-[#4B5262]">
                {m.body}
              </p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </Section>
);

export default Mistakes;
